import { Tab } from '@mui/material'
import styled from '@emotion/styled'
import { fontSize, size } from '@styles/theme'

const StyledTab = styled(Tab)`
  font-size: ${fontSize('sm')};
  color: ${(props) => props.color? props.color : 'white'} !important;
`

export default StyledTab
